import { NgModule } from '@angular/core';
import { DateFormatByUserSettingsPipe } from '@shared/pipes/date-format-by-user-settings/date-format-by-user-settings.pipe';

@NgModule({
  exports: [DateFormatByUserSettingsPipe],
  declarations: [DateFormatByUserSettingsPipe],
})
export class DateFormatByUserSettingsModule {}
